import React, { Suspense } from 'react';
import { SliderCarousel } from './components';
import { fetchEventsSliderByPageGuest } from './utils';

export default async function HeroSlider(): Promise<React.ReactNode> {
  const sliderData = fetchEventsSliderByPageGuest({ limit: 10 });

  return (
    <Suspense fallback={<SliderCarousel sliderEventsData={null} />}>
      <SliderCarousel sliderEventsData={sliderData} />
    </Suspense>
  );
}
